module.exports = __webpack_public_path__ + "static/media/header-image-lg.9f547611.jpg";